const baseUrl = process.env.REACT_APP_API_URL || 'https://brilliant-connect-admin.arafinahmed.com/api';

export default baseUrl;